// js/custom-element/behavior/page-pagination.js
if (!customElements.get('page-pagination')) {
  var PagePagination = class extends CustomHTMLElement {
    connectedCallback() {
      if (this.hasAttribute('ajax')) {
        this.delegate.on('click', 'a', this._onLinkClicked.bind(this));
      }
    }
    _onLinkClicked(event, target) {
      event.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.set('page', target.getAttribute('data-page'));
      triggerEvent(this, 'pagination:page-changed', { url: url.toString() });
    }
  };
  window.customElements.define('page-pagination', PagePagination);
}
